import TaskListWrapper from "../TaskListWrapper";

export default function CompletedList({ list }) {
  return <TaskListWrapper data={list} />;
}
